import React, { useRef, useEffect, useState } from 'react';

const LazyLoadedVideo = ({BannerThumbnail, BannerVideo, pclass=''}) => {
    const [domLoaded, setDomLoaded] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const videoRef = useRef(null);
    const buttonRef = useRef(null);

    function togglePlay() {
      const prevValue = isPlaying;
    
      if (prevValue) {
        videoRef.current.pause();
      }
      else{
        videoRef.current.play();
      }
      setIsPlaying(!prevValue);
  }

  useEffect(() => {
    const handleDomLoaded = () => {
      setDomLoaded(true);
    };

    if(document.readyState !== 'loading'){
        handleDomLoaded();
    }
    else{
    window.addEventListener('DOMContentLoaded', handleDomLoaded);

        return () => {
        window.removeEventListener('DOMContentLoaded', handleDomLoaded);
        };
    }
  }, []);

  useEffect(() => {
    if (domLoaded) {
      // Start playing the video programmatically
      const player = videoRef.current
        if(player){
            player.muted = true;
            player.playsinline = true;
            if(pclass!=='learn' && pclass!=='about-us'){
              player.autoplay = true;
              player.setAttribute('muted', ''); 
            }
            else{
              player.muted = false
            }
             
            player.loop = true;
            
        }
      
      if (videoRef.current && pclass!=='learn' && pclass !== 'about-us') {
        videoRef.current.play().catch(error => {
          // Handle play error (e.g., autoplay policy prevented)
          console.error('Failed to play video:', error);
        });
      }
    }
  }, [domLoaded]);

  return (
    <>
      {domLoaded ? (
        <>
        <video className={`banner_video ${pclass}`} poster={BannerThumbnail} autoPlay={pclass!=='learn'&& pclass !== 'about-us'} loop muted playsInline ref={videoRef}>
          <source src={BannerVideo} type="video/mp4" />
        </video>{
         (pclass === 'learn' || pclass === 'about-us')&& <div className='banner_video_play_pause_container'>
             <button className={`video_button ${isPlaying ? 'pause' : 'play'}`} ref={buttonRef} onClick={togglePlay}/>
          </div>
        }
        </>
      ) : (
        <img src={BannerThumbnail} alt="Thumbnail" height={'400px'} className={`banner_thumbnail ${pclass}`} loading='lazy'/>
      )}
    </>
  );
};


export default LazyLoadedVideo;
